import styled, { css } from 'styled-components';
import { palette } from 'styles/colors';

interface StyledButtonTertiaryProps {
  underlined: boolean;
  hasIcon?: boolean;
  iconPosition?: 'left' | 'right';
  cursor?: 'auto' | 'pointer';
  textColor?: string;
  justify?: 'stretch' | 'center' | 'left' | 'right';
}

export const StyledButtonTertiary = styled.button<StyledButtonTertiaryProps>`
  outline: none;
  background-color: transparent;
  padding: 5px 0.5em;
  border-radius: 0px;
  border-top: none;
  border-left: none;
  border-right: none;
  color: ${({ textColor }) => textColor ?? palette.snowFlower};
  ${({ underlined }) => (underlined ? 'border-bottom: solid 2px ' + palette.text : 'border-bottom: none')};
  ${({ cursor }) => (cursor ? `cursor: ${cursor}` : '')};
  position: relative;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  align-self: center;
  font-family: Mulish;
  justify-self: ${({ justify }) => justify || 'stretch'};
  cursor: pointer;

  ${({ hasIcon, iconPosition }) =>
    hasIcon &&
    css`
      display: grid;
      column-gap: 6px;
      grid-template-columns: ${iconPosition === 'left' ? '24px 1fr' : '1fr 24px'};
    `}
  span {
    align-self: center;
    grid-row: 1 / 2;
  }
`;
